import { ModelBase, Property } from '@skylab-shared/core';

export class ProductRelatedEInvoiceItemModel extends ModelBase {
    @Property()
    public externalId: string;

    @Property()
    public eInvoiceSymbol: string;

    @Property()
    public clientId: number;

    @Property()
    public clientName: string;
}
